"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bar = exports.chart = void 0;

var _util = require("../../../util");

const chart = ({
  theme
}) => ({
  borderBottom: "1px dashed ".concat((0, _util.color)(theme, 'ui3')),
  minHeight: 128
});

exports.chart = chart;

const bar = ({
  cssProps = {},
  theme
}) => {
  const {
    odd = false
  } = cssProps;
  return {
    background: (0, _util.color)(theme, odd ? 'background.gold' : 'background.tan'),
    borderRadius: '2px 2px 0 0',
    maxHeight: '100%',
    minHeight: 0,
    width: 60
  };
};

exports.bar = bar;
//# sourceMappingURL=InsightBarChart.style.js.map